import { ProductAttributes } from '@italist/grpc-proto/services/guardian_pb';
import { Product } from '../../../models/product';
import { formatPrice } from '../../stringFormatters';

/* eslint-disable @typescript-eslint/camelcase */

type GetKlaviyoAddProductData = (
  product: Product,
) => {
  product: Partial<ProductAttributes.AsObject>;
};

export const getKlaviyoAddProductData: GetKlaviyoAddProductData = (product: Product) => {
  const priceUsd = product.priceInAlternativeCurrenciesList
    .filter(price => price.currency === 'USD')
    .map(priceUSD => formatPrice(priceUSD.reducedAfterTax))
    .shift();

  return {
    product: {
      brand: product.brand.name,
      categoryId: product.category.id,
      model: product.model,
      priceUsd,
      productId: product.productId,
    },
  };
};
